import { AUTOMAP_CLIENT_VIEW_SLUG } from "./automapPartnerPortalConfig.js";
import {
  CASAMAPA_CLIENT_VIEW_SLUG,
  CASA_MAPA_PARTNER_PORTAL_TABS,
} from "./casamapaPartnerPortalConfig.js";

export const MIDPOINT_MEDIA_CLIENT_VIEW_SLUG = "midpoint-media";

const DEFAULT_PARTNER_PORTAL_TABS = Object.freeze([
  { segment: "dashboard", label: "Dashboard", icon: "◆", navGroup: "primary" },
  { segment: "leads", label: "Leads", icon: "◈", navGroup: "primary" },
  { segment: "profile", label: "Profile", icon: "◉", navGroup: "primary" },
  { segment: "listing-corrections", label: "Corrections", icon: "✎", navGroup: "secondary" },
  { segment: "sponsorship-assets", label: "Assets", icon: "▣", navGroup: "secondary" },
]);

const MIDPOINT_MEDIA_PARTNER_PORTAL_TABS = Object.freeze([
  { segment: "dashboard", label: "Dashboard", icon: "◆", navGroup: "primary" },
  { segment: "tickets", label: "Tickets", icon: "◈", navGroup: "primary" },
  { segment: "infrastructure", label: "Infrastructure", icon: "◔", navGroup: "primary" },
  { segment: "projects", label: "Projects", icon: "▣", navGroup: "primary" },
  { segment: "profile", label: "Profile", icon: "◉", navGroup: "primary" },
]);

const AUTOMAP_PARTNER_PORTAL_TABS = Object.freeze([
  { segment: "dashboard", label: "Dashboard", icon: "◆", navGroup: "primary" },
  { segment: "dealers", label: "Dealers", icon: "◫", navGroup: "primary" },
  { segment: "inventory-health", label: "Inventory health", icon: "◔", navGroup: "primary" },
  { segment: "whatsapp", label: "WhatsApp Leads", icon: "◬", navGroup: "primary" },
  { segment: "leads", label: "Leads", icon: "◈", navGroup: "primary" },
  { segment: "sponsorship-assets", label: "Sponsorship assets", icon: "▣", navGroup: "secondary" },
  { segment: "sponsorship-placements", label: "Placements", icon: "◎", navGroup: "secondary" },
  { segment: "campaigns", label: "Campaigns", icon: "◐", navGroup: "secondary" },
]);

export function getPartnerPortalConfig(clientViewSlug) {
  if (clientViewSlug === AUTOMAP_CLIENT_VIEW_SLUG) {
    return {
      portalLabel: "AutoMapa admin",
      portalSubtitle:
        "Internal administration for dealer networks, inventory quality, and lead monitoring",
      portalLoadingLabel: "Loading admin console…",
      portalNavAriaLabel: "Admin sections",
      tabs: AUTOMAP_PARTNER_PORTAL_TABS,
    };
  }

  if (clientViewSlug === CASAMAPA_CLIENT_VIEW_SLUG) {
    return {
      portalLabel: "CasaMapa Partner",
      portalSubtitle:
        "Sign in to manage your agency inventory, respond to leads, and keep your business profile up to date on CasaMapa.",
      portalLoadingLabel: "Loading partner portal…",
      portalNavAriaLabel: "Partner portal sections",
      tabs: CASA_MAPA_PARTNER_PORTAL_TABS,
    };
  }

  if (clientViewSlug === MIDPOINT_MEDIA_CLIENT_VIEW_SLUG) {
    return {
      portalLabel: "Midpoint Media Customer Portal",
      portalSubtitle:
        "Report tickets and issues, check infrastructure status, and follow project delivery.",
      portalLoadingLabel: "Loading Midpoint Media customer portal…",
      portalNavAriaLabel: "Midpoint Media customer portal sections",
      tabs: MIDPOINT_MEDIA_PARTNER_PORTAL_TABS,
    };
  }

  return {
    portalLabel: "Partner portal",
    portalSubtitle: "Brokers, agents, vendors, and sponsors",
    portalLoadingLabel: "Loading partner portal…",
    portalNavAriaLabel: "Partner sections",
    tabs: DEFAULT_PARTNER_PORTAL_TABS,
  };
}
